import { ReactNode, useContext } from "react";
import { styled } from "styled-components";
import { CreateTransient } from "../../shared/types";
import { defaultTheme } from "../../shared/constants";
import { Icon } from "../icons";
import { Button } from "../button";
import { ExpandableSectionContext } from "./context";

type ToggleProps = {
  disabled?: boolean;
  children: ReactNode;
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
};

export const Toggle = ({
  disabled = false,
  className,
  children,
}: ToggleProps) => {
  const { isExpanded, toggle } = useContext(ExpandableSectionContext);

  return (
    <Root
      onClick={() => !disabled && toggle?.(!isExpanded)}
      aria-expanded={isExpanded}
      $disabled={disabled}
      className={className}
    >
      <IconWrapper $isExpanded={isExpanded}>
        <StyledButton variant="icon" disabled={disabled}>
          <Icon.Expand />
        </StyledButton>
      </IconWrapper>

      {children}
    </Root>
  );
};

const Root = styled.div<CreateTransient<{ disabled: boolean }>>`
  display: flex;
  height: calc(2 * ${defaultTheme.SPACING.XL});
  align-items: center;
  border-bottom: 1px solid ${defaultTheme.COLORS.GRAY_MEDIUM};

  &:hover {
    cursor: ${(p) => !p.$disabled && "pointer"};
    background-color: ${(p) =>
      !p.$disabled && defaultTheme.COLORS.BLACK_GREY_OPACITY};
  }
`;

const IconWrapper = styled.span<CreateTransient<{ isExpanded: boolean }>>`
  display: flex;
  margin-right: ${defaultTheme.SPACING.SM};
  transform: ${({ $isExpanded }) =>
    $isExpanded ? "rotate(0deg)" : "rotate(-90deg)"};
  transition: transform 200ms ease-in-out;
`;

const StyledButton = styled(Button)`
  border: none;
  background-color: transparent;

  &:hover,
  &:focus {
    border: none;
    background-color: transparent;
  }
`;
